import { render, staticRenderFns } from "./BScroll.vue?vue&type=template&id=585f395a&scoped=true&"
import script from "./BScroll.vue?vue&type=script&lang=js&"
export * from "./BScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f395a",
  null
  
)

export default component.exports